export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  statement: state => state.statement,
  statements: state => state.statements,
  paging: state => state.paging,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/BankStatement/getters.js